export const POLL_INTERVAL = 5000
